import { Button, ConfigProvider, Flex, Modal, Typography } from "antd";
import {
  ModalHeader,
  modalButtonsTheme,
  modalSubtitleStyle,
} from "components/modals/ModalChrome";
import { translate } from "shared/languages";

// Three-way close prompt for a dirty create panel: Simpan Draft (navy
// primary), Buang (solid ink), and stay (X / mask click / Esc). A custom
// Modal rather than showConfirmModal because that helper is two-button by
// design; the chrome (ModalHeader + modalButtonsTheme footer) matches it.
// The wording switches when the panel was resumed from a saved draft — there
// "Buang" means "drop the changes, keep the stored version", never "delete
// the draft".
export const SaveDraftClosePrompt = ({
  open,
  resumed,
  saving,
  onSaveDraft,
  onDiscard,
  onStay,
}: {
  open: boolean;
  resumed: boolean;
  saving: boolean;
  onSaveDraft: () => void;
  onDiscard: () => void;
  onStay: () => void;
}) => (
  <Modal
    open={open}
    footer={null}
    closable
    maskClosable
    width={400}
    onCancel={onStay}
  >
    <ModalHeader
      title={translate(
        resumed
          ? "schedule.drafts.close_prompt.title_resumed"
          : "schedule.drafts.close_prompt.title"
      )}
    />
    <Typography.Text style={modalSubtitleStyle}>
      {translate(
        resumed
          ? "schedule.drafts.close_prompt.body_resumed"
          : "schedule.drafts.close_prompt.body"
      )}
    </Typography.Text>
    <ConfigProvider theme={modalButtonsTheme}>
      <Flex justify="flex-end" gap={10} style={{ marginTop: 22 }}>
        <Button onClick={onDiscard} disabled={saving}>
          {translate(
            resumed
              ? "schedule.drafts.discard_changes"
              : "schedule.drafts.discard"
          )}
        </Button>
        <Button type="primary" loading={saving} onClick={onSaveDraft}>
          {translate(
            resumed ? "schedule.drafts.save_changes" : "schedule.drafts.save"
          )}
        </Button>
      </Flex>
    </ConfigProvider>
  </Modal>
);
